import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, client } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      setUser(await api.me());
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Returning from OAuth: AuthCallback exchanges the session_id first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    const id = client.interceptors.response.use(
      (r) => r,
      (error) => {
        const url = error?.config?.url || "";
        if (error?.response?.status === 401 && !url.startsWith("/auth/")) {
          setUser(null);
        }
        return Promise.reject(error);
      }
    );
    return () => {
      client.interceptors.response.eject(id);
    };
  }, []);

  const logout = async () => {
    try {
      await api.logout();
    } finally {
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
